import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/shared/api/errors';

/**
 * Server-state cache (ADR-0008). Client errors (4xx) are never retried; network and server errors are
 * retried twice. When any request answers 401, `onUnauthenticated` sends the person to sign in.
 */
export function createQueryClient(onUnauthenticated: () => void): QueryClient {
  const handle = (error: Error) => {
    if (error instanceof ApiError && error.status === 401) onUnauthenticated();
  };
  return new QueryClient({
    queryCache: new QueryCache({ onError: handle }),
    mutationCache: new MutationCache({ onError: handle }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          const clientError =
            error instanceof ApiError && error.status >= 400 && error.status < 500;
          return !clientError && failureCount < 2;
        },
      },
    },
  });
}
